import { render, staticRenderFns } from "./rustContractDetector.vue?vue&type=template&id=72215105&scoped=true&"
import script from "./rustContractDetector.vue?vue&type=script&lang=js&"
export * from "./rustContractDetector.vue?vue&type=script&lang=js&"
import style0 from "./rustContractDetector.vue?vue&type=style&index=0&id=72215105&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72215105",
  null
  
)

export default component.exports